import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { withWidth } from '@material-ui/core';

const useStyles = makeStyles({
  countdownContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  countdownText: {
    fontFamily: 'monarcha,open-sans !important',
    fontWeight: 'bold',
    textShadow: '0 0 0.1vw #fff, 0 0 0.05vw #fff, 0 0 1.1vw #ffbf12',
    color: '#ffffff',
    textAlign: 'center',
    width: '600px', // Fixed width to prevent shaking
    fontFeatureSettings: '"tnum"', // Enable tabular numbers
    fontVariantNumeric: 'tabular-nums', // Use monospace numbers
  },
  timezoneText: {
    fontSize: '0.5em',
    verticalAlign: 'super',
    marginLeft: '8px',
  }
});

const Countdown = ({ width }) => {
  const classes = useStyles();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      // Get current date/time in UTC
      const now = new Date();
      
      // Create target date (August 10, 2025 3:00:00 PM Pacific Time)
      // Pacific Time is UTC-7 during daylight saving time
      // 22:00 UTC = 3:00 PM PT (19:00 + 3 hours)
      const targetDate = new Date(Date.UTC(2025, 7, 10, 22, 0, 0)); // Month is 0-based, so 7 is August
      
      // Calculate time difference in milliseconds
      const difference = targetDate.getTime() - now.getTime();

      if (difference > 0) {
        // Convert to days, hours, minutes, seconds
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    // Initial calculation
    calculateTimeLeft();

    // Update every second
    const interval = setInterval(calculateTimeLeft, 1000);

    // Cleanup
    return () => clearInterval(interval);
  }, []);

  const formattedTime = `${timeLeft.days}d ${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(2, '0')}:${String(timeLeft.seconds).padStart(2, '0')}`;

  return (
    <Box className={classes.countdownContainer}>
      <Typography variant={width === 'xs' ? 'h2' : width!=='xl'? 'h2':'h3'} className={classes.countdownText}>
        {formattedTime}
        <span className={classes.timezoneText}>PT</span>
      </Typography>
    </Box>
  );
};

export default withWidth()(Countdown); 